import angular from 'angular'
import rfpHotel from './main/rfp-hotel.module'

export default angular.module('rb.rfpHotel', [ rfpHotel.name ])
